<script lang="ts">import { expandGameInfo, hasGtDemo } from "@infinitro/catalog-min";
import { cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isFullScreenGame, isMobile, loggedIn } from "@infinitro/global";
import { onDestroy, onMount } from "svelte";
import InfoAccordion from "./parts/info-accordion.svelte";
export let game;
game = expandGameInfo(game);
const game_has_no_demo_play = !hasGtDemo(game.f ?? 0);
let messageListener;
onMount(() => {
	messageListener = (event) => {
		if (event.data.action === "scrollToTop") {
			window?.scrollTo(0, 0);
		}
		if (event.data.action === "viewCalculations") {
			window.location.href = "/fairness/";
		}
	};
	window?.addEventListener("message", messageListener);
});
onDestroy(() => {
	window?.removeEventListener("message", messageListener);
});
$: showLogoWhenPlayingDesktop = $stateUi.games.showLogoWhenPlayingDesktop;
$: hasInfoAccordionData = Boolean(game?.game?.trim() || game?.prov?.trim());
</script>

<div class="game-page-container">
	{#if !$isMobile && !$isFullScreenGame && showLogoWhenPlayingDesktop}
		<div class="game-page-logo">
			<img src={cfgToThemeCdnPath('/misc/logo.svg')} alt={$t(Verbiage.site_logo_alt, 'alts')} />
		</div>
	{/if}
	<slot name="game-slot"></slot>
	{#if !$isFullScreenGame}
		<div class="game-page-content">
			{#if hasInfoAccordionData}
				<InfoAccordion {game} />
			{/if}
		</div>
		<slot name="betfeed-slot"></slot>
	{/if}
	<slot name="seo-slot"></slot>
</div>

<style>
	.game-page-container {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		max-width: calc((var(--app-vh, 100vh) - 72px - 50px) * 16 / 9);
		max-width: calc((100dvh - 72px - 50px) * 16 / 9);
		margin: 0 auto
}

	.game-page-content {
		margin-bottom: 1rem;
		margin-top: 1rem;
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 2rem
}

	.game-page-logo {
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center
}
</style>
